import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorImg from '../assets/full_page_error.svg?react';
import PageLayoutView from '../components/layout/PageLayoutView';
import './ErrorView.less';

const ErrorView = ({
  children = 'Use the link from the Welcome email to start again.',
}: PropsWithChildren) => {
  return (
    <div className={'error-view-container'}>
      <ErrorImg />
      <h3 className={'error-view-container-text'}>Unable to continue</h3>
      <span>{children}</span>
    </div>
  );
};

const ErrorViewWithLayoutView = ({
  title = 'Imprivata Hub',
}: PropsWithChildren<{ title?: string }>) => {
  const { t } = useTranslation();
  return (
    <PageLayoutView title={title}>
      <ErrorView>{t('errors.something-unexpected')}</ErrorView>
    </PageLayoutView>
  );
};

export { ErrorView, ErrorViewWithLayoutView };
